<template>
  <b-modal
    v-model="modalVisible"
    title="استيراد ملف JXL"
    hide-footer
    @hidden="$emit('hidden')"
  >
    <b-form-file
      v-model="localJxlImportFile"
      accept=".jxl"
      :disabled="jxlImportLoading || isRawControlUploadDisabled"
      :state="localJxlImportFile ? true : null"
      placeholder="اختر ملف JXL"
      drop-placeholder="اسحب ملف JXL هنا"
      browse-text="تصفح"
    />

    <b-alert
      v-if="isRawControlUploadDisabled"
      variant="warning"
      show
      class="mt-2 mb-2 small"
    >
      <small>
        <template v-if="!surveyUploadMethodId">
          يرجى اختيار طريقة الرفع المساحي أولاً
        </template>
        <template v-else-if="surveyUploadMethodId === 2 && !selectedFixedPointId">
          يرجى اختيار النقطة الثابتة أولاً
        </template>
        <template v-else-if="surveyUploadMethodId === 3 && !selectedStaticPointId">
          يرجى اختيار النقطة الثابتة أولاً
        </template>
        <template v-else-if="surveyUploadMethodId === 4 && !selectedCorrectedStaticPointId">
          يرجى اختيار النقطة الثابتة المصححة أولاً
        </template>
      </small>
    </b-alert>

    <b-alert
      v-if="jxlImportError"
      variant="danger"
      show
      class="mt-3"
    >
      {{ jxlImportError }}
    </b-alert>

    <div
      v-if="jxlImportResult"
      class="mt-3"
    >
      <b-alert
        variant="success"
        show
      >
        <h6>تم الاستيراد بنجاح!</h6>
        <p><strong>اسم الملف:</strong> {{ jxlImportResult.file_name }}</p>
        <p><strong>معرف JXL:</strong> {{ jxlImportResult.jxl_id }}</p>
        <p><strong>عدد النقاط المحفوظة:</strong> {{ jxlImportResult.stored_points_count }}</p>
      </b-alert>
    </div>

    <div class="d-flex justify-content-end mt-2">
      <b-button
        variant="outline-secondary"
        class="ml-1"
        :disabled="jxlImportLoading"
        @click="modalVisible = false"
      >
        إلغاء
      </b-button>
      <b-button
        variant="primary"
        :disabled="jxlImportLoading || !localJxlImportFile || isRawControlUploadDisabled"
        @click="$emit('submit')"
      >
        <b-spinner
          v-if="jxlImportLoading"
          small
          class="mr-1"
        />
        <span v-else>استيراد</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BFormFile, BAlert, BButton, BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'JxlImportModal',
  components: {
    BModal,
    BFormFile,
    BAlert,
    BButton,
    BSpinner,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    jxlImportFile: {
      type: [File, Object, String, null],
      default: null,
    },
    jxlImportLoading: {
      type: Boolean,
      default: false,
    },
    isRawControlUploadDisabled: {
      type: Boolean,
      default: false,
    },
    surveyUploadMethodId: {
      type: Number,
      default: null,
    },
    selectedFixedPointId: {
      type: Number,
      default: null,
    },
    selectedStaticPointId: {
      type: Number,
      default: null,
    },
    selectedCorrectedStaticPointId: {
      type: Number,
      default: null,
    },
    jxlImportError: {
      type: String,
      default: '',
    },
    jxlImportResult: {
      type: Object,
      default: null,
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    localJxlImportFile: {
      get() {
        return this.jxlImportFile
      },
      set(value) {
        this.$emit('update:jxlImportFile', value)
      },
    },
  },
}
</script>
